import { hexColors } from '@mobi/settings'

export type ButtonColor =
  | 'primary'
  | 'secondary'
  | 'light'
  | 'dark'
  | 'muted'
  | 'danger'
  | 'link'
  | 'tab'
  | 'tab_invert'

export type ButtonTypes = Record<ButtonColor, ButtonType>

// We lock down the signature of the button object to ensure that all buttons share the
// same properties to assign a color to. This enables us to safely use it as follows:
// `colors.buttons[color]`
type ButtonType = {
  text: string
  background: string
  gradientBackgroundTop?: string
  gradientBackgroundBottom?: string
  border: string
  hover: {
    background: string
  }
  selected: {
    background: string
    text?: string
    border?: string
    hover: {
      background: string
    }
  }
  disabled: {
    text?: string
    background: string
  }
}

export const buttonColors: ButtonTypes = {
  primary: {
    text: hexColors.white,
    background: hexColors.sushi,
    border: 'transparent',
    hover: {
      background: '#4f792b',
    },
    selected: {
      background: '#37541d',
      hover: {
        background: '#1e2e10',
      },
    },
    disabled: {
      background: '#b6da96',
    },
  },
  secondary: {
    text: hexColors.nightRider,
    background: hexColors.white,
    border: hexColors.veryLightGrey,
    hover: {
      background: hexColors.whiteSmoke,
    },
    selected: {
      background: '#c1c1c1',
      hover: {
        background: '#a8a8a8',
      },
    },
    disabled: {
      text: '#808080',
      background: hexColors.white,
    },
  },
  light: {
    text: hexColors.black,
    background: hexColors.white,
    border: 'transparent',
    hover: {
      background: '#e6e6e6',
    },
    selected: {
      background: '#ccc',
      hover: {
        background: '#b3b3b3',
      },
    },
    disabled: {
      background: '#ccc',
    },
  },
  dark: {
    text: hexColors.white,
    background: hexColors.nero,
    border: 'transparent',
    hover: {
      background: hexColors.charCoal,
    },
    selected: {
      background: '#5a5a5a',
      hover: {
        background: '#737373',
      },
    },
    disabled: {
      background: '#737373',
    },
  },
  muted: {
    text: hexColors.black,
    background: hexColors.whiteSmoke,
    border: 'transparent',
    hover: {
      background: '#dbdbdb',
    },
    selected: {
      background: '#c1c1c1',
      hover: {
        background: '#a8a8a8',
      },
    },
    disabled: {
      background: '#c1c1c1',
    },
  },
  danger: {
    text: hexColors.white,
    background: hexColors.freeSpeechRed,
    border: 'transparent',
    hover: {
      background: '#9a0303',
    },
    selected: {
      background: '#680202',
      hover: {
        background: '#360101',
      },
    },
    disabled: {
      text: 'rgba(64,64,64,0.85)',
      background: hexColors.veryLightGrey,
    },
  },
  link: {
    text: hexColors.studio,
    background: 'transparent',
    border: 'transparent',
    hover: {
      background: hexColors.white,
    },
    selected: {
      background: hexColors.white,
      hover: {
        background: hexColors.white,
      },
    },
    disabled: {
      text: 'rgba(64,64,64,0.85)',
      background: hexColors.veryLightGrey,
    },
  },
  tab: {
    text: hexColors.white,
    background: hexColors.blueDiamond,
    border: 'transparent',
    hover: {
      background: '#874bb5',
    },
    selected: {
      background: '#361e49',
      hover: {
        background: '#361e49',
      },
    },
    disabled: {
      background: hexColors.darkGrey,
    },
  },
  tab_invert: {
    text: hexColors.blueDiamond,
    background: hexColors.white,
    border: 'transparent',
    hover: {
      background: '#ccc',
    },
    selected: {
      background: '#e6e6e6',
      hover: {
        background: '#e6e6e6',
      },
    },
    disabled: {
      background: hexColors.darkGrey,
    },
  },
}
